module.exports = __webpack_public_path__ + "img/portfolio-04-670x479.4307fd8b.jpg";